/**
 * GSAP ScrollTrigger Animations for the Shopify Theme
 * 
 * Target-rich selectors for both Dawn's theme elements and the local preview,
 * with prefers-reduced-motion protection and desktop-only execution limits.
 */
(() => {
  // Check for GSAP and ScrollTrigger availability
  if (!window.gsap || !window.ScrollTrigger) {
    console.warn('[GSAP-ANIM] GSAP or ScrollTrigger is missing. Animations skipped.');
    return;
  }

  // Register ScrollTrigger plugin with GSAP
  window.gsap.registerPlugin(window.ScrollTrigger);

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) {
    console.log('[GSAP-ANIM] prefers-reduced-motion detected. Animations disabled.');
    return;
  }

  // Desktop-only animation constraints
  const mm = window.gsap.matchMedia();
  mm.add('(min-width: 750px)', () => {
    console.log('[GSAP-ANIM] Initializing premium scroll trigger animations.');

    // 1. Hero 3D Reveal (Staggered Intro)
    const heroContent = document.querySelector('.hero-3d__content-inner');
    if (heroContent) {
      window.gsap.from(heroContent.children, {
        y: 40,
        opacity: 0,
        duration: 1.2,
        stagger: 0.18,
        ease: 'power4.out',
        clearProps: 'all'
      });
    }

    // 2. Section Titles Fade-in & Slide Up
    const titleSelectors = [
      '.title-wrapper-with-link .title',
      '.preview-featured-collection__title',
      '.rich-text__heading',
      '.multicolumn-card__info h3'
    ];
    titleSelectors.forEach(selector => {
      window.gsap.utils.toArray(selector).forEach(title => {
        window.gsap.from(title, {
          scrollTrigger: {
            trigger: title,
            start: 'top 85%',
            toggleActions: 'play none none none'
          },
          y: 25,
          opacity: 0,
          duration: 0.8,
          ease: 'power3.out',
          clearProps: 'all'
        });
      });
    });

    // 3. Staggered Product Cards & Multicolumn Grid Items Reveal
    const gridSelectors = [
      { container: '.grid', items: '.grid__item' },
      { container: '.preview-products-grid', items: '.preview-product-card' },
      { container: '.multicolumn-list', items: '.multicolumn-list__item' }
    ];

    gridSelectors.forEach(grid => {
      const containerEl = document.querySelector(grid.container);
      if (containerEl) {
        window.gsap.from(grid.items, {
          scrollTrigger: {
            trigger: containerEl,
            start: 'top 82%',
            toggleActions: 'play none none none'
          },
          y: 45,
          opacity: 0,
          duration: 0.9,
          stagger: 0.08,
          ease: 'power3.out',
          clearProps: 'all'
        });
      }
    });
  });
})();
